"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CenterList = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var message_1 = require("../../model/message");
var service_1 = require("../../../library/base/service");
var CenterList = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(CenterList, _super);
    function CenterList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '消息中心列表查询';
        _this.code = '101008';
        _this.desc = '消息中心列表查询';
        _this.requestParams = new message_1.CenterListRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return CenterList;
}(service_1.BaseService));
exports.CenterList = CenterList;
//# sourceMappingURL=centerList.js.map